import {
  getCookie,
  removeCookieOnDomain,
  setCookieOnDomain
} from 'utils/cookies'

const ACCESS_TOKEN_COOKIE = 'access_token'
const IMPERSONATOR_TOKEN_COOKIE = 'impersonator_token'
const HOME_PATH = '/biblioteca'
const COOKIE_EXPIRATION_DAYS = 30

export const isImpersonating = (): boolean =>
  Boolean(getCookie(IMPERSONATOR_TOKEN_COOKIE))

export const stopImpersonating = (): void => {
  const impersonatorToken = getCookie(IMPERSONATOR_TOKEN_COOKIE)

  if (impersonatorToken) {
    setCookieOnDomain(
      ACCESS_TOKEN_COOKIE,
      impersonatorToken,
      COOKIE_EXPIRATION_DAYS
    )
  } else {
    removeCookieOnDomain(ACCESS_TOKEN_COOKIE)
  }

  removeCookieOnDomain(IMPERSONATOR_TOKEN_COOKIE)

  window.location.href = HOME_PATH
}
